export default __webpack_public_path__ + "static/media/discord.52bb6525.svg";